<template>
    <div class="flex">
        <image-button
                @click.native="showModal = true"
                img="/images/svg/ATS3bdSeriesicon_index.svg"
        >
            build index
        </image-button>

        <portal to="modals" v-if="showModal">
            <modal-bottom v-if="showModal" @close="close()" class="bg-grey-lighter">
                <h3 slot="header">Index</h3>
                <!--
                <p class="text-grey-dark text-sm leading-normal">
                    Calculating index numbers helps to make time series comparisons easy (if the series are not already
                    available as an index).
                    An index defines any year as base year, at an index number of 1.<br>
                    Select a common base year for all the time series selected<br>
                    Deviations from 1 in previous and subsequent years mean<br>
                    - percentage decreases push the index number below 1 (an index number of 0.95 means a 5% fall from
                    the base year)<br>
                    - percentage increases push the index number above 1 (an index number of 1.05 means a 5% rise from
                    the base year)
                </p>
                -->

                <div slot="save" v-show="index !== null">
                    <a class="cursor-pointer inline-block bg-blue text-white px-4 py-2 rounded" v-show="true"
                       @click="save()">
                        Apply
                    </a>
                </div>

                <p class="my-4">Chose base time:</p>
                <div class="mb-8 py-2">
                    <div class="flex flex-wrap">
                        <select v-model="index" class="border p-2 rounded border-blue-dark">
                            <option
                                    v-for="time in times"
                                    class="bg-white cursor-pointer text-center px-4 py-2 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                                    v-bind:value="time">
                                {{ time }}
                            </option>
                        </select> <span class="ml-4"> = 1</span>

                    </div>
                </div>

                <!-- @click.stop="update('index', selected, time); time = null"-->
            </modal-bottom>
        </portal>

    </div>
</template>

<script>

    import ImageButton from "../ImageButton";
    import ModalBottom from "../ModalBottom";
    import IndexModifier from "../../modifiers/IndexModifier";

    export default {
        name: "ComputeIndex",

        components: {ModalBottom, ImageButton},

        data: () => ({
            showModal: false,
            index: null,
        }),

        computed: {
            times() {
                return this.$store.getters.times;
            },
            selected() {
                return this.$store.state.rawData.data[this.$store.state.periodicity].data.map(function (item, index) {
                    return index;
                });
            },
        },

        watch: {
            index() {
                this.modify()
            },
            showModal() {
                this.index = null;
            },
        },

        methods: {
            close() {
                this.$store.dispatch('abort');
                this.showModal = false;
            },
            modify() {
                if (this.index === null) {
                    return;
                }
                this.$store.dispatch('setModifier', {
                    modifier: new IndexModifier({index: this.index}),
                    ids: this.selected
                });
            },
            save() {
                this.$store.dispatch('save');
                this.showModal = false;
            }
        }
    }
</script>

<style scoped>

</style>
